import { createApi } from '@reduxjs/toolkit/query/react';
import {
  Attachment,
  MessageContact,
  AppointmentContact,
  Response,
} from './models';
import { baseApi } from '@centerpiece/components';

export const email = baseApi
  .enhanceEndpoints({ addTagTypes: ['Emails', 'Email'] })
  .injectEndpoints({
    endpoints: builder => ({
      getEmail: builder.query<
        MessageContact | AppointmentContact,
        { params?: object }
      >({
        query: ({ params }: { params?: object }) => ({
          url: 'email',
          method: 'GET',
          params: params,
        }),
        // providesTags: (result, error, arg) => [{ type: 'Email', id: arg }],
      }),
      getEmailAttachment: builder.query<Attachment, { params?: object }>({
        query: ({ params }: { params?: object }) => ({
          url: 'email',
          method: 'GET',
          params: params,
        }),
        // providesTags: (result, error, arg) => [{ type: 'Email', id: arg }],
      }),
      createEmail: builder.mutation<Response, void>({
        query: request => ({
          url: 'email',
          method: 'POST',
          body: request,
        }),
        // invalidatesTags: ['Emails'],
      }),
      updateEmail: builder.mutation<MessageContact, MessageContact>({
        query: request => ({
          url: `email`,
          method: 'PUT',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'Email', id: arg.id },
        ],
      }),
      patchEmail: builder.mutation<MessageContact, MessageContact>({
        query: request => ({
          url: `email`,
          method: 'PATCH',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'Email', id: arg.id },
        ],
      }),
    }),
  });

// Auto-generated hooks
export const {
  usePatchEmailMutation,
  useGetEmailQuery,
  useLazyGetEmailAttachmentQuery,
  useCreateEmailMutation,
  useUpdateEmailMutation,
  usePrefetch: useEmailsPrefetch,
} = email;
